import { render, staticRenderFns } from "./OnusPreCadastro.vue?vue&type=template&id=32639b3d&"
import script from "./OnusPreCadastro.vue?vue&type=script&lang=js&"
export * from "./OnusPreCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports